module.exports = __webpack_public_path__ + "img/truck-ramp.3c3ddb44.svg";